import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const createClient = async (clientData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/clients/create", clientData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateClient = async (
  id: string,
  clientData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/users/edit/${id}`, clientData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserById = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.get(`/users/view/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteClient = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/allusers/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
